module.exports = __webpack_public_path__ + "data_manager.7815d37dbba5d38bc11a3abf8a31a6ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/selected/data_manager.svg
// module id = 354
// module chunks = 0